import React from "react";
import { getTileView } from "../CrossLinkFunction";
import Tile from "../Tile/Tile";

const CrossTemplate = ({ cross_template_links }) => {
    
    const isContent = cross_template_links && Object.keys(cross_template_links).length

    return (<>
        {isContent ? Object.keys(cross_template_links).map((key, index) => {
            const dataSet = cross_template_links[key];
            const { title } = dataSet;
            const { view: view_data, isDataPresent: is_present } = getTileView(dataSet)

            return (
                <Tile key={index} tileHeading={title} tileContent={view_data} isTileContent={is_present}></Tile>
            )
        })
            : <></>}
    </>);
}

export default CrossTemplate;
